<template>
    <div
        class="tile"
        @mouseenter="flip = true"
        @mouseleave="flip = false"
        @touchend.stop="flip = true"
    >
        <div class="tile-inner" :class="{flip}">
            <div class="tile-front">
                <div class="name">{{character.name}}</div>
                <img :src="character.imgUrl" />
            </div>
            <div class="tile-back" @touchend.stop="flip = false">
                <div class="underlay">
                    <i class="link-out fa fa-external-link" style="font-size:24px" @click="onCharClick(character.linkUrl)"></i>
                </div>
                <div class="aka" v-if="character.aka.length">
                    <div>Also Known As: {{ akaString(character) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ICharacter from '@/characters.ts'
export default {
  name: 'Tile',
  props: {
    character: ICharacter
  },
  components: {
  },
  data: () => {
    return {
        flip: false
    }
  },
  methods: {
    akaString(character) {
        return character.aka.join(', ')
    },
    onCharClick(linkUrl) {
        window.location = linkUrl
    }
  }
}
</script>

<style scoped>
.tile {
    aspect-ratio: 5 / 7;
    position: relative;
    background-color: red;
    box-sizing: border-box;
    border-radius: 16px;
    border: 3px solid red;
    overflow: hidden;
    cursor: pointer;
    perspective: 100vw;
}

.tile img {
    max-width:100%;
    max-height:100%;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.name {
    border-width: 2px 2px 0px 0px;
    border-style: solid;
    border-color: red;
    border-top-right-radius: 16px;
    position: absolute;
    background-color: black;
    font-size: 20px;
    padding: 1px 5px 1px 5px;
    bottom: 0;
}

.tile-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

.tile-inner.flip {
  transform: rotateY(180deg);
}

.tile-front, .tile-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 16px;
}

.tile-front {
  background-color: #bbb;
  color: white;
}

.tile-back {
  background-color: dodgerblue;
  color: white;
  transform: rotateY(180deg);
}

.underlay {
    position: relative;
    transform: translateX(calc(50% - 24px));
}

.link-out {
    background-color: black;
    border-width: 0px 0px 2px 2px;
    border-style: solid;
    border-color: red;
    border-bottom-left-radius: 16px;
    padding: 10px;
}

.aka {
    border-width: 2px 0px 0px 0px;
    border-style: solid;
    border-color: red;
    position: absolute;
    bottom: 0;
    padding: 5px;
    background-color: black;
    width: 100%;
}
</style>